import { Outlet } from "react-router-dom"
import { usePermissions } from "@/hooks/use-permissions"
import { useAuthStore } from "@/stores/auth-store"

interface PermissionRouteProps {
  permission: string
}

export function PermissionRoute({ permission }: PermissionRouteProps) {
  const { hasPermission } = usePermissions()
  const isLoading = useAuthStore((state) => state.isLoading)

  if (isLoading) {
    return null
  }

  if (!hasPermission(permission)) {
    return (
      <div className="flex h-svh flex-col items-center justify-center gap-2">
        <h1 className="text-2xl font-semibold">Accès refusé</h1>
        <p className="text-sm text-muted-foreground">
          Vous n'avez pas la permission d'accéder à cette page.
        </p>
      </div>
    )
  }

  return <Outlet />
}
